// Per-event tag for Mixpanel. When this tool supports multiple supplements in
// one session, call sites will pass the active record's supplement instead of
// this constant (see mixpanel tracking in streak-tracker.tsx).
export const SUPPLEMENT = "creatine" as const;

export type Milestone = {
  days: number;
  name: string;
  icon: string;
};

export type CreatineTip = {
  text: string;
  source: string;
};

export const MILESTONES: readonly Milestone[] = [
  { days: 7, name: 'Loaded', icon: '✦' },
  { days: 14, name: 'Locked In', icon: '◆' },
  { days: 30, name: 'Saturated', icon: '★' },
  { days: 60, name: 'Dedicated', icon: '✸' },
  { days: 90, name: 'Elite', icon: '♛' },
];

export const CREATINE_TIPS: readonly CreatineTip[] = [
  {
    text: 'Creatine is one of the most studied supplements in history, with over 500 peer-reviewed papers confirming its safety and efficacy.',
    source: 'ISSN Position Stand, 2017',
  },
  {
    text: 'Your muscles store about 95% of your creatine. Daily supplementation keeps those stores full for strength and power output.',
    source: 'J. Int. Soc. Sports Nutrition',
  },
  {
    text: 'Creatine absorbs ~25% better with a meal. Insulin from carbs and protein helps drive it into muscle cells.',
    source: 'J. Applied Physiology, 2000',
  },
  {
    text: 'It takes about 28 days of daily creatine to fully saturate your muscles. Consistency matters more than timing.',
    source: 'Hultman et al., 1996',
  },
  {
    text: 'Creatine supports cognitive function under stress and sleep deprivation, not just physical performance.',
    source: 'Psychopharmacology, 2018',
  },
  {
    text: "Creatine doesn't cause dehydration — even in heat. An extra glass of water per serving supports the osmotic effect.",
    source: 'ISSN Position Stand, 2017',
  },
  {
    text: 'Creatine monohydrate is the gold standard. No other form has been shown to be more effective in research.',
    source: 'J. Int. Soc. Sports Nutrition',
  },
];

// TODO: When multi-supplement is added, create TIPS_BY_PRODUCT map keyed by product ID
// and switch streak-tracker.tsx to use it instead of CREATINE_TIPS directly.
